import { Drawer, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import {theme} from '../../../theme';
import React from 'react';
import ImageContainer from './ImageContainer';
import DrawerHeader from '../../CustomComponents/DrawerHeader';

function PackItemDetails({ packItem, open, onClose }) {

    return (
        <Drawer
            anchor="right"
            open={open}
            onClose={onClose}
            PaperProps={{ sx: { width: { xs: '100%', sm: '75%', md: '50%' }, maxWidth: '600px', } }}
        >
            {packItem && (
                <>
                    <DrawerHeader handleBack={onClose} title="More Details" />
                    <Stack backgroundColor={theme.palette.background.categoryDrawer} spacing={2} p={2} height='100%'>
                        <Stack spacing={1.5} p={2} backgroundColor={theme.palette.background.white} borderRadius={1} >
                            <Typography variant="heavy">Pack Item Information</Typography>
                            <Typography variant="normal" sx={{ fontSize: '14px' }}><strong>Name: </strong>{packItem.name}</Typography>
                            <Typography variant="normal" sx={{ fontSize: '14px' }}><strong>Manufacturer: </strong>{packItem.vendor_name}</Typography>
                            <Typography variant="normal" sx={{ fontSize: '14px' }}><strong>Reference Number: </strong>{packItem.catalog_number}</Typography>
                            <Typography variant="normal" sx={{ fontSize: '14px' }}><strong>Unit Price: </strong>${(packItem.cost_per_uom / 100).toFixed(2)}</Typography>
                        </Stack>
                        { packItem.images && packItem.images.length > 0 &&
                            <Stack p={2} spacing={2} backgroundColor={theme.palette.background.white} borderRadius={1}>
                                <ImageContainer images={packItem.images}/>
                            </Stack>
                        }
                    </Stack>
                </>
            )}
        </Drawer>
    );
}

export default PackItemDetails;